import { z } from 'zod';

export const MIN_BIRTHDATE_YEAR = 1900;

export const objectTypeSchema = z.enum([
  'NOMINATION',
  'PROFILE',
  'NEED',
  'EVENT',
  'DAILY_GOOD',
  'GOOD_VIBE',
  'CHALLENGE',
  'RAFFLE',
  'CHALLENGE_GROUP',
  'STREAK',
  'STRUCTURE',
  'SHARE',
  'MERCHANDISE',
  'NONE'
]);

export type ObjectType = z.infer<typeof objectTypeSchema>;

export const PASSWORD_MIN_LENGTH = 8;

// password regex
export const passwordRegex = {
  uppercase: /(?=.*[A-Z])/,
  lowercase: /(?=.*[a-z])/,
  number: /(?=.*\d)/,
  specialChar: /(?=.*[!@#$%^&*()_+=\-[\]{};':"\\|,.<>/?~])/,
  noWhitespace: /^\S*$/
};
